import type { ReactNode } from "react";
import { CABINET_COORDINATES } from "../_data/constants";

const { latitude, longitude } = CABINET_COORDINATES;

const GOOGLE_DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=driving`;
const APPLE_DIRECTIONS_URL = `https://maps.apple.com/?daddr=${latitude},${longitude}&dirflg=d`;

// Sur iPhone/iPad/Mac on bascule vers Apple Plans natif au moment du clic
// (pas de SSR mismatch : le href par défaut reste Google côté serveur/client).
function preferAppleOnClick(e: React.MouseEvent<HTMLAnchorElement>) {
  if (
    typeof navigator !== "undefined" &&
    /iPhone|iPad|Mac/.test(navigator.userAgent)
  ) {
    e.currentTarget.href = APPLE_DIRECTIONS_URL;
  }
}

export function DirectionsLink({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <a
      href={GOOGLE_DIRECTIONS_URL}
      data-href-apple={APPLE_DIRECTIONS_URL}
      onClick={preferAppleOnClick}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}
